import './Footer.scss';
function Footer(){
  return (
    <footer>
      <a className="social-icon" href="https://discord.gg/vYmvFBZQsM">discord</a>
      <a className="social-icon" href="https://www.linkedin.com/in/scott-casey-20210398/">linkedin</a>
      <a className="social-icon" href="https://www.patreon.com/kurohyoustudios?fan_landing=true">patreon</a>
      <a className="social-icon" href="https://github.com/Kurohyou">github</a>
      <a className="social-icon" href="https://twitter.com/Kurohyoustudios">twitter</a>
    </footer>
  )
};
export default Footer;